import React from "react";
import PropTypes from "prop-types";
import { Box, FormControl, InputLabel, MenuItem, Select, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1, 1.5),
  },
  selectWrap: {
    minWidth: 280,
    width: "100%",
    maxWidth: 520,
    flex: 1,
  },
  meta: {
    color: "#556070",
    whiteSpace: "nowrap",
  },
}));

const SeasonSelector = ({ selectedSeasonId, seasonOptions, onSeasonChange }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography variant="body1" className={classes.meta}>
        シーズン：
      </Typography>
      <Box className={classes.selectWrap}>
        <FormControl variant="outlined" fullWidth size="small">
          <Select
            labelId="regular-season-selector-label"
            value={selectedSeasonId}
            onChange={onSeasonChange}
          >
            {seasonOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

SeasonSelector.propTypes = {
  selectedSeasonId: PropTypes.string.isRequired,
  seasonOptions: PropTypes.array.isRequired,
  onSeasonChange: PropTypes.func.isRequired,
};

export default SeasonSelector;
